"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipBadge = MembershipBadge;
var jsx_runtime_1 = require("react/jsx-runtime");
// ================================================================
// v2/components/MembershipBadge/index.tsx
// 「🔒 メンバーシップ限定」ピル。会員限定コンテンツの目印として
// EventDetail / Store / Card サムネ等で横断利用する。
//
// 文言はこのパッケージが i18n を持たないため必須 props で受ける
// (既定値を持つと呼び出し側が翻訳を通し忘れたまま日本語が出てしまう)。
//
// Figma: 背景 background.neutral.default / 枠なし / radius-full (ピル) /
// gap 2px / px6 py2。錠前アイコン + 文字ともに foreground.primary.main /
// 12px W600 (JP/Subtitle2) nowrap。
// 色はすべて theme.palette.v2 (useV2Palette) から取得する。
// ================================================================
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var tokens_1 = require("../../tokens");
var Icons_1 = require("../Icons");
function MembershipBadge(_a) {
    var label = _a.label, _b = _a.icon, icon = _b === void 0 ? (0, jsx_runtime_1.jsx)(Icons_1.LockIcon, { filled: false, sx: { fontSize: 12 } }) : _b;
    var p = (0, theme_1.useV2Palette)();
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '2px',
            px: '6px',
            py: '2px',
            borderRadius: "".concat(tokens_1.radius.full, "px"),
            backgroundColor: p.background.neutral.default,
            color: p.foreground.primary.main,
        }, children: [icon != null && ((0, jsx_runtime_1.jsx)(material_1.Box, { component: "span", sx: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    fontSize: 12,
                    lineHeight: 1,
                }, children: icon })), (0, jsx_runtime_1.jsx)(material_1.Typography, { sx: {
                    px: '2px',
                    fontSize: 12,
                    fontWeight: tokens_1.fontWeight.semiBold,
                    lineHeight: '16px',
                    color: p.foreground.primary.main,
                    whiteSpace: 'nowrap',
                }, children: label })] }));
}
